module.exports = __webpack_public_path__ + "static/media/back_arrow.310c02c1.svg";